import type { PublicCampaignSchema } from "@/types";
import i18n from "@/i18n";

/** The tournament subtype carried on the `campaigns` stream ("PT" | "HC" | …). */
type Subtype = PublicCampaignSchema["subtype"];

/**
 * True when scores are shown with an "x" multiplier suffix (highest-coin style).
 * The subtype is authoritative now that it rides `campaigns` — no more scanning
 * payloads / `campaign_info` JSON for a `tournament_type` (the old heuristic).
 */
export function isHighestWinStyleTournament(
  subtype: Subtype | undefined
): boolean {
  return subtype === "HC";
}

/** Leaderboard score-column heading: "Points" for point tournaments and races (a race scores
 *  points too, over a capped number of spins), else "Score". */
export function getTournamentScoreColumnLabel(
  subtype: Subtype | undefined
): string {
  if (subtype === "PT" || subtype === "RA") {
    return i18n.t("tournament.scoreType.pointTournament");
  }
  return i18n.t("tournament.scoreType.highestWinTournament");
}
